(function () {
  "use strict";

  /* ---------- Money formatting ---------- */
  function formatMoney(cents, format) {
    format = format || window.themeMoneyFormat || "${{amount}}";
    var value = (cents / 100).toFixed(2);
    var parts = value.split(".");
    var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    var noDecimals = withCommas;
    var withDecimals = withCommas + "." + parts[1];
    return format
      .replace(/\{\{\s*amount\s*\}\}/, withDecimals)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDecimals)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withDecimals);
  }

  /* ---------- Mobile menu ---------- */
  var burger = document.getElementById("MobileMenuToggle");
  var mobileMenu = document.getElementById("MobileMenu");
  if (burger && mobileMenu) {
    burger.addEventListener("click", function () {
      var isOpen = mobileMenu.classList.toggle("open");
      burger.setAttribute("aria-expanded", isOpen ? "true" : "false");
    });
  }

  /* ---------- Product gallery thumbnails ---------- */
  document.querySelectorAll(".media-thumbs").forEach(function (group) {
    var mainId = group.getAttribute("data-main-image");
    var mainImg = mainId ? document.getElementById(mainId) : null;
    group.querySelectorAll(".thumb").forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        group.querySelectorAll(".thumb").forEach(function (t) { t.classList.remove("active"); });
        thumb.classList.add("active");
        if (mainImg) mainImg.src = thumb.getAttribute("data-full");
      });
    });
  });

  /* ---------- Cart drawer open/close ---------- */
  var drawer = document.getElementById("CartDrawer");
  var cartTrigger = document.getElementById("CartIconTrigger");

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add("open");
    drawer.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove("open");
    drawer.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
  }
  if (drawer) {
    drawer.querySelectorAll("[data-cart-drawer-close]").forEach(function (el) {
      el.addEventListener("click", closeDrawer);
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") closeDrawer();
    });
  }
  if (cartTrigger && drawer) {
    cartTrigger.addEventListener("click", function (e) {
      e.preventDefault();
      refreshCartDrawer(openDrawer);
    });
  }

  function updateCartCount(count) {
    var badge = document.getElementById("CartCount");
    if (!badge) return;
    badge.textContent = count;
    badge.hidden = count === 0;
  }

  function refreshCartDrawer(callback) {
    fetch(window.location.pathname + "?section_id=cart-drawer")
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, "text/html");
        var fresh = doc.getElementById("CartDrawer");
        if (fresh && drawer) {
          drawer.innerHTML = fresh.innerHTML;
          drawer.querySelectorAll("[data-cart-drawer-close]").forEach(function (el) {
            el.addEventListener("click", closeDrawer);
          });
          bindDrawerQtyInputs();
        }
        if (typeof callback === "function") callback();
      })
      .catch(function () {
        if (typeof callback === "function") callback();
      });
  }

  function bindDrawerQtyInputs() {
    document.querySelectorAll(".cart-drawer-qty").forEach(function (input) {
      input.addEventListener("change", function () {
        var line = input.getAttribute("data-line");
        var qty = parseInt(input.value, 10);
        if (isNaN(qty) || qty < 0) qty = 0;
        fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ line: line, quantity: qty })
        })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            updateCartCount(cart.item_count);
            refreshCartDrawer();
          });
      });
    });
  }
  bindDrawerQtyInputs();

  /* ---------- Buy box: variant selection + add to cart ---------- */
  document.querySelectorAll("[data-buy-box]").forEach(function (box) {
    var script = box.querySelector(".product-variants-json");
    var variants = [];
    try { variants = JSON.parse(script.textContent); } catch (e) { variants = []; }

    var idInput = box.querySelector(".variant-id-input");
    var priceEl = box.querySelector(".buy-box-price");
    var compareEl = box.querySelector(".buy-box-compare");
    var addBtn = box.querySelector(".add-to-cart-btn");
    var addBtnText = addBtn ? addBtn.querySelector(".btn-text") : null;
    var errorEl = box.querySelector(".add-to-cart-error");
    var form = box.querySelector("form");
    var optionGroups = box.querySelectorAll(".option-group");

    var selected = {};
    optionGroups.forEach(function (group) {
      var activePill = group.querySelector(".option-pill.active");
      var idx = group.getAttribute("data-option-index");
      if (activePill) selected[idx] = activePill.getAttribute("data-value");
    });

    function findVariant() {
      return variants.find(function (v) {
        var opts = [v.option1, v.option2, v.option3];
        return Object.keys(selected).every(function (idx) {
          return opts[parseInt(idx, 10)] === selected[idx];
        });
      });
    }

    function applyVariant(variant) {
      if (!variant) return;
      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = formatMoney(variant.compare_at_price);
          compareEl.style.display = "";
        } else {
          compareEl.style.display = "none";
        }
      }
      if (addBtn) addBtn.disabled = !variant.available;
      if (addBtnText) addBtnText.textContent = variant.available ? "Add to Bag" : "Sold Out";
    }

    optionGroups.forEach(function (group) {
      var idx = group.getAttribute("data-option-index");
      group.querySelectorAll(".option-pill").forEach(function (pill) {
        pill.addEventListener("click", function () {
          group.querySelectorAll(".option-pill").forEach(function (p) { p.classList.remove("active"); });
          pill.classList.add("active");
          selected[idx] = pill.getAttribute("data-value");
          applyVariant(findVariant());
        });
      });
    });

    if (form) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        if (errorEl) { errorEl.hidden = true; errorEl.textContent = ""; }
        if (addBtn) addBtn.disabled = true;

        var formData = new FormData(form);
        fetch("/cart/add.js", {
          method: "POST",
          headers: { Accept: "application/json" },
          body: formData
        })
          .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
          .then(function (result) {
            if (!result.ok) {
              throw new Error(result.data && result.data.description ? result.data.description : "Could not add to bag");
            }
            return fetch("/cart.js").then(function (r) { return r.json(); });
          })
          .then(function (cart) {
            updateCartCount(cart.item_count);
            if (drawer) {
              refreshCartDrawer(openDrawer);
            } else {
              window.location.href = "/cart";
            }
          })
          .catch(function (err) {
            if (errorEl) {
              errorEl.textContent = err.message || "Something went wrong. Please try again.";
              errorEl.hidden = false;
            } else {
              form.submit();
            }
          })
          .finally(function () {
            var v = findVariant();
            if (addBtn) addBtn.disabled = v ? !v.available : false;
          });
      });
    }
  });
})();
